import { t } from "../../../i18n";
import { Button, Dialog } from "../../ui";
import type { CategoryItem } from "../utils";

interface DeleteCategoryDialogProps {
  category: CategoryItem | null;
  open: boolean;
  onClose: () => void;
  onConfirm: (category: CategoryItem) => void;
}

export function DeleteCategoryDialog({
  category,
  open,
  onClose,
  onConfirm,
}: DeleteCategoryDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={t.household.categories.deleteDialog.title}
      description={
        category ? t.household.categories.deleteDialog.description(category.name) : undefined
      }
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>{t.common.cancel}</Button>
          <Button
            variant="danger"
            iconLeft="trash"
            disabled={!category}
            onClick={() => category && onConfirm(category)}
          >
            {t.household.categories.deleteDialog.submit}
          </Button>
        </>
      }
    >
      {null}
    </Dialog>
  );
}
